import {sendPasswordResetEmail} from "firebase/auth";
import {auth} from "../config";

export const sendPasswordReset = async (email: string) => {
        await sendPasswordResetEmail(auth, email);
};
